import * as React from 'react';
import {Image, ImageStyle, View, ViewStyle} from 'react-native';

import Icon from '/component/base/Icon';
import {COACH, RANK_BY_ID} from '/enum/rank.enum';

import {RANK_ICON_NAME, SHIELD_HEIGHT, SHIELD_WIDTH} from './config';
import {styles} from './RankIcon.style';
import ShieldImage from './shield.png';

interface StyleProps {
  base: ViewStyle;
  shield: ImageStyle;
  iconContainer: ViewStyle;
  icon: ViewStyle;
}

interface RankIconProps {
  style: Partial<StyleProps>;
  rankId: number;
  rank: keyof typeof RANK_ICON_NAME;
  scale: number;
}

const RankIcon: React.FC<RankIconProps> = ({
  style = {},
  rankId = 0,
  rank = COACH,
  scale = 1,
}) => {
  const baseStyle = [styles.base, style.base];
  const shieldStyle = [
    styles.shield,
    {
      width: SHIELD_WIDTH * scale,
      height: SHIELD_HEIGHT * scale,
      marginTop: -25,
    },
    style.shield,
  ];
  const iconContainerStyle = [styles.iconContainer, style.iconContainer];

  const iconStyle = {
    ...styles.icon,
    marginTop: -25,
    transform: [{scale}],
    ...(style.icon || {}),
  };

  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const rankName = RANK_BY_ID[rankId] || rank;
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const iconName = RANK_ICON_NAME[rankName] ?? '';

  return (
    <View style={baseStyle}>
      <Image source={ShieldImage} style={shieldStyle} />
      <View style={iconContainerStyle}>
        <Icon
          name={iconName}
          style={iconStyle}
          accessible={false}
          accessibilityElementsHidden
          importantForAccessibility="no-hide-descendants"
        />
      </View>
    </View>
  );
};

export default RankIcon;
